import { catchError, exhaustMap, filter, mergeMap } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { toast } from 'react-toastify'
import { createOrderRequest, createOrderSuccess, createOrderFailure, getTradingHistoryRequest } from '../actions'
import { RootEpic } from '../types'

export const createOrderEpic: RootEpic = (action$, state$, { createOrder }) => {
  return action$.pipe(
    filter(isActionOf([createOrderRequest])),
    exhaustMap(({ payload }) =>
      from(
        createOrder({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        mergeMap((response) => {
          toast(response.message, { type: response.success ? 'success' : 'error' })
          if (response.success) {
            return of(createOrderSuccess(response), getTradingHistoryRequest({ idSf: response.idSf, page: 1 }))
          }
          return of(createOrderSuccess(response))
        }),
        catchError((error) => {
          toast.error(error?.response?.data?.message || 'Failed to create order.')
          return of(createOrderFailure(error))
        }),
      ),
    ),
  )
}

export default [createOrderEpic]
